import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-xl text-background-50"></i>
                </div>
                <span className="text-lg font-bold text-background-50">春色影视</span>
              </div>
              <p className="text-sm leading-relaxed">
                春色影视致力于为广大用户提供高清流畅的在线观影体验。海量影视资源，实时更新，免费观看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
              <div className="flex flex-col gap-2">
                {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                <Link to="/category/action" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">热门动作片</Link>
                <Link to="/category/comedy" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">热门喜剧片</Link>
                <Link to="/category/drama" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">热门剧情片</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">免责声明</h4>
              <p className="text-sm leading-relaxed">
                本站所有视频内容均来自互联网，仅供网友学习交流之用。如涉及版权问题，请及时联系我们处理。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs">
              &copy; 2026 春色影视. 保留所有权利.
            </p>
            <p className="text-xs">
              高清免费在线观看 | 不缓冲流畅播放 | 秒开无卡顿
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}